import { render, staticRenderFns } from "./collectUnit.vue?vue&type=template&id=5f1b8958&scoped=true"
import script from "./collectUnit.vue?vue&type=script&lang=js"
export * from "./collectUnit.vue?vue&type=script&lang=js"
import style0 from "./collectUnit.vue?vue&type=style&index=0&id=5f1b8958&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1b8958",
  null
  
)

export default component.exports